export { TextArea, type TextAreaProps } from './TextArea';
